import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const editWorkflowEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(
			/* webpackChunkName: "global-settings-issues-workflow-edit" */ './EditWorkflow.tsx'
		).then((module) => module.EditWorkflow),
	),
	getPreloadProps: () => ({}),
});
